import { styled } from '@mui/system';

export const CheckboxMainContainer = styled('div')({
	width: '100%',
});
